<template>
  <div id="connected-lang" class="container-fluid">
    <h2>Brilliant! You are now enjoying Premium Wifi!</h2>
    <h2>Explore Brilliant by Langham benefits</h2>

    <div class="icon-array">
      <ul class="icon-ul">
        <li>
          <div class="icon-box"><img src="@/components/custom/langhamNewYorkNew/img/ratesIcon.svg" alt=""></div>
          <p>Member Rates</p>
        </li>
        <li>
          <div class="icon-box"><img src="@/components/custom/langhamNewYorkNew/img/diningIcon.svg" alt=""></div>
          <p>Dining Discounts</p>
        </li>
        <li>
          <div class="icon-box"><img src="@/components/custom/langhamNewYorkNew/img/eventIcon.svg" alt=""></div>
          <p>VIP Event Access</p>
        </li>
      </ul>

      <a v-if="joined" href="https://www.brilliantbylangham.com/en" class="solid-button">EXPLORE MORE</a>
      <div v-else class="solid-button" v-on:click="clickJoin">JOIN NOW</div>
      <a :href="portal.template.redirect_url" >Close</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      joined: Boolean,
      portal: Object,
    },
    methods: {
      clickJoin: function () {
        this.$emit('emitClickedJoin');
      }
    },
    mounted(){
      // console.log(this.portal);
    },
  };
</script>

<style scoped>
  #connected-lang {
    color:  black;
    width: 72.5%;
    margin: 0px auto;
  }

  h2 {
    font-family: serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1.35rem;
    line-height: 1.5rem;
    text-align: center;
    letter-spacing: 1px;
    color: #000000;
    margin-top: 20px;
  }

  .icon-array {
    width: 100%;
    margin: 30px auto;
    padding: 20px 2.5rem;
  }

  .icon-ul {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    gap: 20px 0;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
  }

  .icon-ul > li {
    width: 33.3%;
    display: list-item;
    text-align: -webkit-match-parent;
  }

  .icon-ul > li > .icon-box {
    width: 100px;
    margin: auto;
  }

  .icon-ul > li > .icon-box > img {
    width: 100%;
  }

  .icon-ul > li > p {
    font-family: serif;
    font-style: normal;
    font-size: 1.35rem;
    line-height: 1.5rem;
    text-align: center;
    letter-spacing: 1px;
    color: #000000;
    margin-top: 2.5rem;
  }

  .solid-button {
    display: block;
    width: 50% !important;
    padding: 10px 0 !important;
    font-size: 1rem !important;
    line-height: 1rem !important;
    background-color: #17dbcc;
    opacity: 0.5;
    letter-spacing: 1px !important;
    border-radius: 32px;
    color: #151515;
    font-weight: 700 !important;
    text-transform: none;
    text-decoration: none;
    cursor: pointer;
    margin: 40px auto 60px;
    box-shadow: none;
    border: none;
    height: 37px !important;
  }

@media (max-width: 768px) {
  .icon-ul {
    flex-direction: column;
    align-items: center;
    gap: 30px; /* Increase vertical spacing if needed */
    margin: 0 auto;
    padding: 0;
    list-style: none;
    width: 100%;
  }

  .icon-ul > li {
    width: 100%; /* Each item takes full width */
    text-align: center;
  }

  .icon-ul > li > .icon-box {
    margin: 0 auto;
  }

  .icon-ul > li > p {
    margin-top: 1.5rem;
    font-size: 1.2rem;
  }
}

</style>